import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('patient', 'create-patient-insurance');

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'patient_insurances',
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/requests/create-patient-insurance.js